export default {
  methods: {
    isDrinkMachine (model) {
      switch (model) {
        case 'D4':
          return true
      }
      return false
    },

    getCoilSettings (settingString) {
      if (!settingString || settingString.length === 0) {
        return [
          { name: 'A', value: '--' },
          { name: 'B', value: '--' },
          { name: 'C', value: '--' },
          { name: 'D', value: '--' },
          { name: 'E', value: '--' },
          { name: 'F', value: '--' }
        ]
      }

      const settings = []

      settingString.split(',').map((setting) => {
        const trimmed = setting.trim()
        settings.push({
          name: trimmed[0],
          value: trimmed.substring(1)
        })
      })

      return settings
    },

    getCoilHeight (settings, label, isDrinkMachine = false) {
      if (isDrinkMachine) {
        let row = label.trim()
        if (row.length === 3) {
          switch (row[0]) {
            case 'A':
            case 'B':
              return '半'
            case 'D':
              return '小'
          }
        }
        return '全'
      } else {
        let found = settings.find(function (setting) {
          return setting.name === label.trim()[0]
        })
        if (found) {
          return found.value.trim()
        }
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/coilSetting.js